(function () {
  if (window.FitpaceFinderV2 && window.FitpaceFinderV2.version) {
    return;
  }

  var STORAGE_KEY = "fitpace_finder_session_id";
  var CTA_VARIANT_SESSION_KEY = "fitpace_finder_v2_cta_variant";
  var ATTRIBUTION_STORAGE_KEY = "fitpace_finder_attribution_v1";
  var instances = {};
  var HEADER_OFFSET_GAP = 32;
  var MOBILE_BASE_PADDING_TOP = 156;
  var DESKTOP_BASE_PADDING_TOP = 208;

  var QUESTIONS = [
    {
      id: "activity",
      title: "Where do you need support most?",
      subtitle: "Pick your primary movement context.",
      options: [
        { value: "sport", label: "Performance & training", description: "Running, gym, and high-impact movement." },
        { value: "standing", label: "All-day standing & work", description: "Long shifts, walking, and on-feet comfort." },
        { value: "daily", label: "Everyday casual use", description: "Daily shoes and routine wear." }
      ],
      weights: {
        sport: { sport: 4, daily: 1 },
        standing: { comfort: 4, daily: 1 },
        daily: { daily: 4, comfort: 1 }
      }
    },
    {
      id: "arch",
      title: "How would you describe your arch profile?",
      subtitle: "Choose the closest match.",
      options: [
        { value: "low", label: "Low / flat arch", description: "Need structure and stability." },
        { value: "neutral", label: "Neutral arch", description: "Balanced support is usually best." },
        { value: "high", label: "High arch", description: "Need pressure distribution and control." }
      ],
      weights: {
        low: { comfort: 2, daily: 1 },
        neutral: { daily: 2, sport: 1 },
        high: { sport: 2, comfort: 1 }
      }
    },
    {
      id: "pain",
      title: "What is your main foot concern?",
      subtitle: "Pick the one that affects you most.",
      options: [
        { value: "heel", label: "Heel pain / plantar stress", description: "Morning heel pain or prolonged soreness." },
        { value: "arch", label: "Arch strain or collapse", description: "Arch fatigue or poor support feeling." },
        { value: "forefoot", label: "Forefoot pressure", description: "Ball-of-foot discomfort and impact pain." },
        { value: "fatigue", label: "General fatigue", description: "Feet feel tired by mid-day." }
      ],
      weights: {
        heel: { comfort: 3, daily: 1 },
        arch: { sport: 2, daily: 2 },
        forefoot: { daily: 3, comfort: 1 },
        fatigue: { comfort: 2, daily: 2 }
      }
    },
    {
      id: "cushion",
      title: "What cushioning feel do you prefer?",
      subtitle: "Choose the underfoot sensation you like.",
      options: [
        { value: "max", label: "Soft and plush", description: "Prioritize comfort and impact absorption." },
        { value: "balanced", label: "Balanced support", description: "Mix of control and comfort." },
        { value: "firm", label: "Responsive and firm", description: "Energy return and stability first." }
      ],
      weights: {
        max: { comfort: 3, daily: 1 },
        balanced: { daily: 2, sport: 1, comfort: 1 },
        firm: { sport: 3, daily: 1 }
      }
    },
    {
      id: "shoe",
      title: "What shoes will you use most with this insole?",
      subtitle: "Pick the shoe category you wear most.",
      options: [
        { value: "running", label: "Running or training shoes", description: "Athletic and movement-first shoes." },
        { value: "work", label: "Work shoes / safety shoes", description: "Long-hour occupational footwear." },
        { value: "casual", label: "Casual sneakers", description: "Everyday shoes and city walking." },
        { value: "boots", label: "Boots", description: "Heavier shoes with longer wear time." }
      ],
      weights: {
        running: { sport: 3, daily: 1 },
        work: { comfort: 3, daily: 1 },
        casual: { daily: 3, comfort: 1 },
        boots: { comfort: 2, daily: 1 }
      }
    }
  ];

  function safeParse(jsonText) {
    try {
      return JSON.parse(jsonText);
    } catch (_error) {
      return null;
    }
  }

  function getConfig(sectionId) {
    var script = document.getElementById("fitpace-finder-v2-config-" + sectionId);
    if (!script) return null;
    return safeParse(script.textContent || "");
  }

  function normalizeProductUrl(rawUrl) {
    if (!rawUrl || typeof rawUrl !== "string") return "/pages/insole-finder";
    return rawUrl
      .replace("shopify://products/", "/products/")
      .replace("shopify://pages/", "/pages/")
      .replace("shopify://collections/", "/collections/");
  }

  function withQueryParams(rawUrl, params) {
    var normalized = normalizeProductUrl(rawUrl);
    try {
      var absolute = normalized.indexOf("http") === 0
        ? normalized
        : window.location.origin + (normalized.charAt(0) === "/" ? "" : "/") + normalized;
      var url = new URL(absolute);
      Object.keys(params || {}).forEach(function (key) {
        var value = params[key];
        if (value !== undefined && value !== null && value !== "") {
          url.searchParams.set(key, String(value));
        }
      });
      return url.pathname + url.search + url.hash;
    } catch (_error) {
      return normalized;
    }
  }

  function buildInboundContext() {
    var params = new URLSearchParams(window.location.search || "");
    return {
      utm_source: params.get("utm_source") || "",
      utm_medium: params.get("utm_medium") || "",
      utm_campaign: params.get("utm_campaign") || "",
      finder_intent: params.get("finder_intent") || "",
      landing_page: params.get("landing_page") || "",
      source_path: params.get("source_path") || ""
    };
  }

  function makeSessionId() {
    return "finder_" + Math.random().toString(36).slice(2, 10) + "_" + Date.now().toString(36);
  }

  function getSessionId() {
    try {
      var existing = window.localStorage.getItem(STORAGE_KEY);
      if (existing) return existing;
      var created = makeSessionId();
      window.localStorage.setItem(STORAGE_KEY, created);
      return created;
    } catch (_error) {
      if (!window.__fitpaceFinderSessionId) {
        window.__fitpaceFinderSessionId = makeSessionId();
      }
      return window.__fitpaceFinderSessionId;
    }
  }

  function createEmptyScores() {
    return { sport: 0, comfort: 0, daily: 0 };
  }

  function getAnswerLabel(questionId, answerValue) {
    var question = QUESTIONS.find(function (item) { return item.id === questionId; });
    if (!question) return answerValue;
    var option = question.options.find(function (item) { return item.value === answerValue; });
    return option ? option.label : answerValue;
  }

  function pushDataLayerEvent(name, payload, trackingEnabled) {
    if (!trackingEnabled) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, payload || {}));
  }

  function persistFinderAttribution(payload) {
    if (!payload || typeof payload !== "object") return;
    var serialized = "";
    try {
      serialized = JSON.stringify(payload);
    } catch (_error) {
      return;
    }

    try {
      window.sessionStorage.setItem(ATTRIBUTION_STORAGE_KEY, serialized);
    } catch (_error2) {}

    try {
      window.localStorage.setItem(ATTRIBUTION_STORAGE_KEY, serialized);
    } catch (_error3) {}

    window.__fitpaceFinderAttribution = payload;
  }

  function Finder(sectionId) {
    this.sectionId = sectionId;
    this.root = document.getElementById("fitpace-finder-v2-" + sectionId);
    this.config = getConfig(sectionId);
    this.inbound = buildInboundContext();
    this.sessionId = getSessionId();
    this.state = {
      step: 0,
      answers: {},
      scores: createEmptyScores(),
      ranked: [],
      lastViewedStep: -1
    };
  }

  Finder.prototype.basePayload = function () {
    return {
      finder_version: "v2",
      finder_session_id: this.sessionId,
      finder_source_page: this.getResolvedSourcePage(),
      finder_intent: this.getResolvedIntent(),
      section_id: this.sectionId
    };
  };

  Finder.prototype.track = function (eventName, payload) {
    pushDataLayerEvent(
      eventName,
      Object.assign(this.basePayload(), payload || {}),
      this.config && this.config.tracking_enabled
    );
  };

  Finder.prototype.trackLegacy = function (eventName, payload) {
    this.track(eventName, payload);
  };

  Finder.prototype.init = function () {
    if (!this.root || !this.config) return;
    this.dom = {
      progressDots: this.root.querySelectorAll("[data-ffv2-dot]"),
      questionPanel: this.root.querySelector("[data-ffv2-question-panel]"),
      resultPanel: this.root.querySelector("[data-ffv2-result-panel]"),
      stepLabel: this.root.querySelector("[data-ffv2-step-label]"),
      questionTitle: this.root.querySelector("[data-ffv2-question-title]"),
      questionSubtitle: this.root.querySelector("[data-ffv2-question-subtitle]"),
      options: this.root.querySelector("[data-ffv2-options]"),
      backButton: this.root.querySelector("[data-ffv2-back]"),
      restartButton: this.root.querySelector("[data-ffv2-restart]"),
      reasons: this.root.querySelector("[data-ffv2-reasons]"),
      primaryCard: this.root.querySelector('[data-ffv2-card="primary"]'),
      secondaryCard: this.root.querySelector('[data-ffv2-card="secondary"]'),
      mobileSticky: this.root.querySelector("[data-ffv2-mobile-sticky]"),
      mobileStickyLink: this.root.querySelector("[data-ffv2-sticky-link]")
    };

    this.updateTopSpacingBound = this.updateTopSpacing.bind(this);
    this.bindLayoutEvents();
    this.bindEvents();
    this.updateTopSpacing();
    this.applySeoOverrides();
    this.render();
    this.track("fitpace_finder_v2_loaded", { page_path: window.location.pathname || "" });
    this.trackLegacy("insole_finder_loaded", { page_path: window.location.pathname || "" });
  };

  Finder.prototype.applySeoOverrides = function () {
    if (!this.config) return;
    var nextTitle = (this.config.seo_title_override || "").trim();
    var nextDescription = (this.config.seo_description_override || "").trim();

    if (nextTitle) {
      document.title = nextTitle;
    }

    if (!nextDescription) return;
    var meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", nextDescription);
  };

  Finder.prototype.bindLayoutEvents = function () {
    if (!this.updateTopSpacingBound) return;
    window.addEventListener("resize", this.updateTopSpacingBound, { passive: true });
    window.addEventListener("orientationchange", this.updateTopSpacingBound, { passive: true });
    window.addEventListener("load", this.updateTopSpacingBound, { passive: true });

    var self = this;
    window.setTimeout(function () {
      self.updateTopSpacing();
    }, 120);
    window.setTimeout(function () {
      self.updateTopSpacing();
    }, 350);
  };

  Finder.prototype.getResolvedSourcePage = function () {
    return this.inbound.landing_page || this.inbound.source_path || window.location.pathname || "";
  };

  Finder.prototype.getResolvedIntent = function () {
    return this.inbound.finder_intent || this.state.answers.activity || "direct";
  };

  Finder.prototype.getHeaderClearance = function () {
    var selectors = [
      ".nav_fixed",
      ".nav_component",
      ".section-header",
      ".shopify-section-group-header-group",
      ".header-wrapper",
      "sticky-header",
      ".utility-bar",
      ".shopify-section-header-sticky",
      "[data-sticky-type='always']",
      "[data-sticky-type='on-scroll-up']"
    ];
    var maxBottom = 0;

    for (var i = 0; i < selectors.length; i += 1) {
      var nodes = document.querySelectorAll(selectors[i]);
      for (var j = 0; j < nodes.length; j += 1) {
        var node = nodes[j];
        if (!node || !node.getBoundingClientRect) continue;
        if (this.root && (node === this.root || node.contains(this.root))) continue;

        var rect = node.getBoundingClientRect();
        if (!rect || rect.height < 20) continue;
        if (rect.bottom <= 0 || rect.top > Math.max(180, window.innerHeight * 0.35)) continue;

        var styles = window.getComputedStyle(node);
        if (!styles || styles.display === "none" || styles.visibility === "hidden") continue;

        var position = styles.position;
        var isOverlay = position === "fixed" || position === "sticky";
        if (!isOverlay && selectors[i] !== ".shopify-section-group-header-group" && selectors[i] !== ".header-wrapper") {
          continue;
        }

        if (rect.bottom > maxBottom) {
          maxBottom = rect.bottom;
        }
      }
    }

    return Math.max(0, Math.ceil(maxBottom));
  };

  Finder.prototype.updateTopSpacing = function () {
    if (!this.root) return;
    var basePadding = window.matchMedia("(max-width: 767px)").matches
      ? MOBILE_BASE_PADDING_TOP
      : DESKTOP_BASE_PADDING_TOP;
    if (window.self !== window.top) {
      basePadding += 52;
    }
    var headerClearance = this.getHeaderClearance();
    var nextPadding = Math.max(basePadding, headerClearance + HEADER_OFFSET_GAP);
    this.root.style.paddingTop = nextPadding + "px";
    this.syncStickyLayout();
  };

  Finder.prototype.getPrimaryCtaMeta = function () {
    var variantRaw = (this.config && this.config.primary_cta_ab_variant) || "a";
    var normalized = String(variantRaw).toLowerCase();
    var variant = "a";
    if (normalized === "b") {
      variant = "b";
    } else if (normalized === "auto") {
      variant = this.getSessionCtaVariant();
    }
    var fallbackLabel = (this.config && this.config.primary_cta_label) || "View product";
    var labelA = (this.config && this.config.primary_cta_label_a) || fallbackLabel || "View product";
    var labelB = (this.config && this.config.primary_cta_label_b) || "Get my fit";
    return {
      variant: variant,
      label: variant === "b" ? labelB : labelA,
      labelA: labelA,
      labelB: labelB
    };
  };

  Finder.prototype.getSessionCtaVariant = function () {
    var createVariant = function () {
      return Math.random() < 0.5 ? "a" : "b";
    };

    try {
      var existing = window.sessionStorage.getItem(CTA_VARIANT_SESSION_KEY);
      if (existing === "a" || existing === "b") {
        return existing;
      }
      var created = createVariant();
      window.sessionStorage.setItem(CTA_VARIANT_SESSION_KEY, created);
      return created;
    } catch (_error) {
      if (!window.__fitpaceFinderCtaVariant) {
        window.__fitpaceFinderCtaVariant = createVariant();
      }
      return window.__fitpaceFinderCtaVariant;
    }
  };

  Finder.prototype.syncStickyLayout = function () {
    if (!this.root || !this.dom || !this.dom.mobileSticky) return;
    var isMobile = window.matchMedia("(max-width: 767px)").matches;
    var isResultVisible = this.dom.resultPanel && !this.dom.resultPanel.hidden;
    var enabled = !!(this.config && this.config.sticky_mobile_cta);
    var shouldShow = isMobile && isResultVisible && enabled;

    this.dom.mobileSticky.hidden = !shouldShow;
    this.root.classList.toggle("ffv2-result-active", !!isResultVisible);
    this.root.classList.toggle("ffv2-has-sticky-cta", shouldShow);

    if (!shouldShow) {
      this.root.style.removeProperty("--ffv2-sticky-offset");
      return;
    }

    var stickyHeight = this.dom.mobileSticky.getBoundingClientRect().height || 72;
    this.root.style.setProperty("--ffv2-sticky-offset", Math.ceil(stickyHeight + 20) + "px");
  };

  Finder.prototype.destroy = function () {
    if (!this.updateTopSpacingBound) return;
    window.removeEventListener("resize", this.updateTopSpacingBound);
    window.removeEventListener("orientationchange", this.updateTopSpacingBound);
    window.removeEventListener("load", this.updateTopSpacingBound);
  };

  Finder.prototype.bindEvents = function () {
    var self = this;
    if (this.dom.backButton) {
      this.dom.backButton.addEventListener("click", function () {
        if (self.state.step > 0) {
          self.state.step -= 1;
          self.render();
        }
      });
    }
    if (this.dom.restartButton) {
      this.dom.restartButton.addEventListener("click", function () {
        self.state = {
          step: 0,
          answers: {},
          scores: createEmptyScores(),
          ranked: [],
          lastViewedStep: -1
        };
        self.render();
        self.track("fitpace_finder_v2_restart", {});
      });
    }
  };

  Finder.prototype.applyScore = function (question, answerValue) {
    var weights = (question.weights && question.weights[answerValue]) || {};
    Object.keys(weights).forEach(function (productKey) {
      if (Object.prototype.hasOwnProperty.call(this.state.scores, productKey)) {
        this.state.scores[productKey] += Number(weights[productKey]) || 0;
      }
    }, this);
  };

  Finder.prototype.computeResults = function () {
    var self = this;
    this.state.scores = createEmptyScores();
    QUESTIONS.forEach(function (question) {
      var answerValue = self.state.answers[question.id];
      if (answerValue) {
        self.applyScore(question, answerValue);
      }
    });
    this.state.ranked = Object.keys(this.state.scores)
      .map(function (key) { return { key: key, score: self.state.scores[key] }; })
      .sort(function (a, b) { return b.score - a.score; });
  };

  Finder.prototype.buildReasons = function () {
    var answers = this.state.answers;
    var reasons = [];
    if (answers.activity) {
      reasons.push("Primary use: " + getAnswerLabel("activity", answers.activity) + ", so support was weighted for that context first.");
    }
    if (answers.pain) {
      reasons.push("Main concern: " + getAnswerLabel("pain", answers.pain) + ", which pushed pressure relief higher in the match.");
    }
    if (answers.cushion) {
      reasons.push("Preferred feel: " + getAnswerLabel("cushion", answers.cushion) + ", which tuned firmness and impact feel.");
    }
    if (answers.shoe) {
      reasons.push("Shoe type: " + getAnswerLabel("shoe", answers.shoe) + ", checked to improve day-one fit compatibility.");
    }
    return reasons.slice(0, 4);
  };

  Finder.prototype.getProductData = function (key) {
    var products = (this.config && this.config.products) || {};
    return products[key] || {
      name: "FITPACE",
      description: "Recommended insole for your profile.",
      url: "/collections/all",
      price: "",
      image: ""
    };
  };

  Finder.prototype.persistAttribution = function (payload) {
    var sourcePage = this.getResolvedSourcePage();
    var merged = Object.assign(
      {
        attribution_version: "v1",
        source_path: window.location.pathname || "",
        finder_source_page: sourcePage,
        finder_intent: this.getResolvedIntent(),
        finder_session_id: this.sessionId,
        utm_source: this.inbound.utm_source || "",
        utm_medium: this.inbound.utm_medium || "",
        utm_campaign: this.inbound.utm_campaign || "",
        updated_at: Date.now()
      },
      payload || {}
    );
    persistFinderAttribution(merged);
  };

  Finder.prototype.buildClickPayload = function (productKey, rank, ctaMeta, placement) {
    var product = this.getProductData(productKey);
    return {
      finder_result_key: productKey,
      finder_result_handle: productKey,
      finder_result_rank: rank,
      finder_result_name: (product && product.name) || "",
      finder_cta_variant: (ctaMeta && ctaMeta.variant) || "",
      finder_cta_label: (ctaMeta && ctaMeta.label) || "",
      finder_cta_placement: placement || "",
      finder_activity: this.state.answers.activity || "",
      finder_arch: this.state.answers.arch || "",
      finder_pain: this.state.answers.pain || "",
      finder_cushion: this.state.answers.cushion || "",
      finder_shoe: this.state.answers.shoe || ""
    };
  };

  Finder.prototype.buildTrackedHref = function (rawUrl, productKey, rank, ctaMeta, placement) {
    var sourcePage = this.getResolvedSourcePage();
    return withQueryParams(rawUrl || "/collections/all", {
      utm_source: this.inbound.utm_source || "insole_finder",
      utm_medium: this.inbound.utm_medium || "quiz_v2",
      utm_campaign: this.inbound.utm_campaign || "finder_result_v2",
      finder_version: "v2",
      finder_session_id: this.sessionId,
      finder_intent: this.getResolvedIntent(),
      finder_source_page: sourcePage,
      finder_result_key: productKey,
      finder_result_handle: productKey,
      finder_result_rank: rank,
      finder_cta_variant: (ctaMeta && ctaMeta.variant) || "",
      finder_cta_label: (ctaMeta && ctaMeta.label) || "",
      finder_cta_placement: placement || "",
      finder_activity: this.state.answers.activity || "",
      finder_arch: this.state.answers.arch || "",
      finder_pain: this.state.answers.pain || "",
      finder_cushion: this.state.answers.cushion || "",
      finder_shoe: this.state.answers.shoe || ""
    });
  };

  Finder.prototype.bindCard = function (card, productKey, rank, badgeLabel, ctaMeta, placement) {
    if (!card) return;
    var product = this.getProductData(productKey);
    var nameEl = card.querySelector("[data-ffv2-name]");
    var descEl = card.querySelector("[data-ffv2-desc]");
    var priceEl = card.querySelector("[data-ffv2-price]");
    var buttonEl = card.querySelector("[data-ffv2-link]");
    var badgeEl = card.querySelector("[data-ffv2-badge]");
    var imageEl = card.querySelector("[data-ffv2-image]");

    if (nameEl) nameEl.textContent = product.name || "FITPACE";
    if (descEl) descEl.textContent = product.description || "";
    if (priceEl) priceEl.textContent = product.price || "";
    if (badgeEl) badgeEl.textContent = badgeLabel;
    if (imageEl && product.image) {
      imageEl.src = product.image;
      imageEl.alt = product.name || "FITPACE insole";
      imageEl.hidden = false;
    } else if (imageEl) {
      imageEl.hidden = true;
    }

    if (!buttonEl) return;
    if (ctaMeta && ctaMeta.label) {
      buttonEl.textContent = ctaMeta.label;
    }
    var href = this.buildTrackedHref(product.url || "/collections/all", productKey, rank, ctaMeta, placement);
    buttonEl.setAttribute("href", href);

    var self = this;
    var cloned = buttonEl.cloneNode(true);
    cloned.addEventListener("click", function () {
      var payload = self.buildClickPayload(productKey, rank, ctaMeta, placement);
      self.persistAttribution(Object.assign({}, payload, {
        attribution_stage: "result_click",
        click_destination: href
      }));
      self.track("fitpace_finder_v2_product_click", payload);
      self.trackLegacy("insole_finder_cta_click", payload);
    });
    buttonEl.parentNode.replaceChild(cloned, buttonEl);
  };

  Finder.prototype.bindStickyCta = function (productKey, ctaMeta) {
    if (!this.dom || !this.dom.mobileStickyLink) return;
    var linkEl = this.dom.mobileStickyLink;
    var product = this.getProductData(productKey);
    if (ctaMeta && ctaMeta.label) {
      linkEl.textContent = ctaMeta.label;
    }
    var href = this.buildTrackedHref(product.url || "/collections/all", productKey, 1, ctaMeta, "mobile_sticky_primary");
    linkEl.setAttribute("href", href);

    var self = this;
    var cloned = linkEl.cloneNode(true);
    cloned.addEventListener("click", function () {
      var payload = self.buildClickPayload(productKey, 1, ctaMeta, "mobile_sticky_primary");
      self.persistAttribution(Object.assign({}, payload, {
        attribution_stage: "mobile_sticky_click",
        click_destination: href
      }));
      self.track("fitpace_finder_v2_product_click", payload);
      self.trackLegacy("insole_finder_cta_click", payload);
    });
    linkEl.parentNode.replaceChild(cloned, linkEl);
    this.dom.mobileStickyLink = cloned;
  };

  Finder.prototype.renderProgress = function () {
    var step = this.state.step;
    for (var i = 0; i < this.dom.progressDots.length; i += 1) {
      var dot = this.dom.progressDots[i];
      dot.classList.remove("is-active", "is-complete");
      if (step > i) {
        dot.classList.add("is-complete");
      } else if (step === i) {
        dot.classList.add("is-active");
      }
    }
  };

  Finder.prototype.renderQuestion = function () {
    var question = QUESTIONS[this.state.step];
    if (!question) return;
    this.dom.questionPanel.hidden = false;
    this.dom.resultPanel.hidden = true;
    this.dom.stepLabel.textContent = "Step " + (this.state.step + 1) + " of " + QUESTIONS.length;
    this.dom.questionTitle.textContent = question.title;
    this.dom.questionSubtitle.textContent = question.subtitle;
    this.dom.options.innerHTML = "";

    var self = this;
    question.options.forEach(function (option) {
      var button = document.createElement("button");
      button.type = "button";
      button.className = "ffv2-option";
      button.innerHTML = (
        '<p class="ffv2-option__label">' + option.label + "</p>" +
        '<p class="ffv2-option__desc">' + option.description + "</p>"
      );
      button.addEventListener("click", function () {
        self.state.answers[question.id] = option.value;
        self.track("fitpace_finder_v2_answer_selected", {
          question_id: question.id,
          answer_value: option.value
        });
        if (question.id === "activity") {
          self.trackLegacy("insole_finder_q1_selected", {
            finder_activity: option.value,
            finder_activity_label: option.label
          });
        }
        self.state.step += 1;
        if (self.state.step >= QUESTIONS.length) {
          self.computeResults();
        }
        self.render();
      });
      self.dom.options.appendChild(button);
    });

    this.dom.backButton.hidden = this.state.step === 0;
    this.syncStickyLayout();

    if (this.state.lastViewedStep !== this.state.step) {
      this.track("fitpace_finder_v2_step_view", { step: this.state.step + 1 });
      this.state.lastViewedStep = this.state.step;
    }
  };

  Finder.prototype.renderResult = function () {
    this.dom.questionPanel.hidden = true;
    this.dom.resultPanel.hidden = false;
    this.dom.backButton.hidden = true;

    var ranked = this.state.ranked;
    var primary = ranked[0] ? ranked[0].key : "daily";
    var secondary = ranked[1] ? ranked[1].key : "comfort";
    var showSecondary = !!(this.config && this.config.show_secondary_result);
    var primaryCtaMeta = this.getPrimaryCtaMeta();
    var secondaryCtaMeta = {
      variant: "secondary",
      label: (this.config && this.config.secondary_cta_label) || "View alternative"
    };

    this.bindCard(this.dom.primaryCard, primary, 1, this.config.primary_badge_label || "Best match", primaryCtaMeta, "result_primary");
    this.bindCard(this.dom.secondaryCard, secondary, 2, this.config.secondary_badge_label || "Alternative", secondaryCtaMeta, "result_secondary");
    this.bindStickyCta(primary, primaryCtaMeta);
    if (this.dom.secondaryCard) {
      this.dom.secondaryCard.hidden = !showSecondary;
    }

    var reasons = this.buildReasons();
    this.dom.reasons.innerHTML = "";
    reasons.forEach(function (reason) {
      var li = document.createElement("li");
      li.textContent = reason;
      this.dom.reasons.appendChild(li);
    }, this);

    var resultPayload = {
      finder_result_key: primary,
      finder_result_handle: primary,
      finder_result_name: this.getProductData(primary).name || "",
      finder_result_alternative: secondary,
      finder_cta_variant: primaryCtaMeta.variant,
      finder_cta_label: primaryCtaMeta.label,
      finder_activity: this.state.answers.activity || "",
      finder_arch: this.state.answers.arch || "",
      finder_pain: this.state.answers.pain || "",
      finder_cushion: this.state.answers.cushion || "",
      finder_shoe: this.state.answers.shoe || ""
    };
    this.persistAttribution(Object.assign({}, resultPayload, {
      attribution_stage: "result_view"
    }));
    this.track("fitpace_finder_v2_result_view", resultPayload);
    this.trackLegacy("insole_finder_result_view", resultPayload);
    this.syncStickyLayout();
  };

  Finder.prototype.render = function () {
    if (!this.dom) return;
    this.renderProgress();
    if (this.state.step < QUESTIONS.length) {
      this.renderQuestion();
    } else {
      this.renderResult();
    }
  };

  function boot(sectionId) {
    if (!sectionId || instances[sectionId]) return;
    var instance = new Finder(sectionId);
    if (!instance.root || !instance.config) return;
    instance.init();
    instances[sectionId] = instance;
  }

  function bootQueued() {
    var queue = window.FitpaceFinderV2Queue || [];
    queue.forEach(function (sectionId) {
      boot(sectionId);
    });
  }

  window.FitpaceFinderV2 = {
    version: "1.1.0",
    boot: boot,
    bootQueued: bootQueued
  };

  document.addEventListener("DOMContentLoaded", bootQueued);

  if (document.readyState !== "loading") {
    bootQueued();
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (event && event.detail && event.detail.sectionId) {
      boot(event.detail.sectionId);
    }
  });

  document.addEventListener("shopify:section:unload", function (event) {
    if (event && event.detail && event.detail.sectionId) {
      var instance = instances[event.detail.sectionId];
      if (instance && typeof instance.destroy === "function") {
        instance.destroy();
      }
      delete instances[event.detail.sectionId];
    }
  });
})();
